var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPolish(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "polish",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 100.75,
    height: 90.013,
    viewBox: "0 0 100.75 90.013",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_57",
    "data-name": "Rectangle 57",
    width: 100.75,
    height: 90.013,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_73",
    "data-name": "Group 73",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_291",
    "data-name": "Path 291",
    d: "M40.477,74.69l0,13.739a1.585,1.585,0,0,0,1.579,1.584l21.863-.007A1.574,1.574,0,0,0,65.5,88.421l0-13.731Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_292",
    "data-name": "Path 292",
    d: "M60.152,55.548c-2.388,0-5.417-1.464-8.454-3.555-.271.014-.546.023-.826.023l-18.481.006c-3.419,0-6.262-.52-6.99-3.716L0,48.314V72.2H65.494l-.006-19.877-1.9,1.9a4.7,4.7,0,0,1-3.438,1.331"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_293",
    "data-name": "Path 293",
    d: "M55.3,24.845l3.532-3.532a7.226,7.226,0,0,1,1.423-3.485,5.179,5.179,0,0,0-2.865-.867l-6.308,0a5.242,5.242,0,0,0-3.788,1.625L35.517,1.859A3.153,3.153,0,0,0,32.785.278L0,.289V3.322l30.981-.01L40.922,20.62a4.706,4.706,0,0,1,3.343-1.244c3.467,0,7.947,3.008,11.036,5.469"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_294",
    "data-name": "Path 294",
    d: "M35.454,26.081l1.886-1.886c-5.673-.4-17.074-.935-37.34-.97V45.141l25.4-.008c.407-1.794,8.378-2.747,15.294-3.239a42.6,42.6,0,0,1-4.569-6.376c-2.425-4.282-2.651-7.457-.671-9.437"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_295",
    "data-name": "Path 295",
    d: "M62.354,36.083c-.056,0-.111.02-.167.02a3.016,3.016,0,0,1-1.075-.2l-1.438,1.438a3,3,0,0,1-2.122.879,2.968,2.968,0,0,1-.785-.1A7.854,7.854,0,0,1,51.555,32.9,3,3,0,0,1,52.329,30l1.523-1.522a2.991,2.991,0,0,1-.115-.823c0-.065.015-.128.019-.193-3.9-3.159-7.456-5.084-9.49-5.084a1.791,1.791,0,0,0-1.316.452L37.576,28.2c-1.827,1.827,2.041,8.656,8.639,15.254,5.492,5.492,11.143,9.092,13.938,9.092a1.791,1.791,0,0,0,1.316-.452c1.107-1.108,4.267-4.267,5.374-5.374,1.4-1.4-.545-5.727-4.489-10.639m.219,10.666-2.759,2.758c-1.632-.337-6.106-2.8-11.477-8.172-5.426-5.426-7.862-9.859-8.178-11.473l4.44-4.44c.869.193,2.938,1.042,6.1,3.439a4.984,4.984,0,0,0-1.044,4.559,9.82,9.82,0,0,0,6.6,6.6,4.965,4.965,0,0,0,4.558-1.042c2.29,3.026,3.247,5.157,3.446,6.092Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_296",
    "data-name": "Path 296",
    d: "M100.75,29.581,86.371,17.8l2.642-2.642a4.28,4.28,0,0,0,0-6.036c-.058-.058-.12-.109-.18-.163a4.28,4.28,0,0,0-.071-5.957L87,1.245a4.28,4.28,0,0,0-6.036,0L63.024,19.185A4.266,4.266,0,0,0,61.8,22.592l-5.061,5.061,1.09,1.09L54.45,32.119a4.883,4.883,0,0,0,3.1,3.1l3.376-3.377L62.186,33.1l.47-.239a4.885,4.885,0,0,1,7.554-6.108l3.065,3.066a4.224,4.224,0,0,0,2.241-1.162l.8-.8,1.306,2.916a3.076,3.076,0,0,0-.7-3.276c-.04-.041-.082-.08-.125-.119l.474-.474,2.271,1.586,1.425-.922,8.886,7.042s-.158,2.532.678,3.368a.827.827,0,0,0,.077.069c.754.618,2.632.674,3.289.674.146,0,.232,0,.232,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_297",
    "data-name": "Path 297",
    d: "M68.088,28.877a1.886,1.886,0,0,0-2.667,2.667l13.2,13.2a1.886,1.886,0,0,0,2.667-2.667Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolish);
export default __webpack_public_path__ + "static/media/polish.92ca64ede98f4b8acdd6560f30367f79.svg";
export { ForwardRef as ReactComponent };